import { gql } from "@apollo/client";

export const UpdateJunctionPriority = gql`
  mutation UpdateJunctionPriority(
    $token: String!
    $junctionIds: [ID!]!
    $user_details: SubscribedUser!
    $priority: PriorityType!
  ) {
    UpdateJunctionPriority(
      token: $token
      junctionIds: $junctionIds
      user_details: $user_details
      priority: $priority
    )
  }
`;
